var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{attrs:{"id":"live-update-controller"}},[_c('div',{class:{
    disconnected: !_vm.connected,
    'disconnected-shouldreload': _vm.shouldReload
  }},[_c('font-awesome-icon',{directives:[{name:"show",rawName:"v-show",value:(_vm.checkConnect),expression:"checkConnect"}],staticClass:"icon",attrs:{"icon":_vm.faCircle,"title":_vm.connected ? _vm.$t('CONNECTED'): _vm.$t('DISCONNECTED')}})],1)])}
var staticRenderFns = []

export { render, staticRenderFns }